import styled from 'styled-components';

const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${({ theme }) => theme.size.spacing.medium.value};
`;

export { Row };
